export const Currencies = Object.freeze({
    CAD: '$',
    CNY: '¥',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    USD: '$',
    ZAR: 'R',
});
